import React, { useState } from 'react';

interface CopyableValueProps {
  value: string;
  className?: string;
  showCopyIcon?: boolean;
  children?: React.ReactNode;
}

const CopyableValue: React.FC<CopyableValueProps> = ({ 
  value, 
  className = "", 
  children 
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const displayValue = children || value;

  return (
    <div 
      className={`relative inline-flex items-center gap-2 group ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span 
        className={`text-sm text-semantic-text-secondary cursor-pointer transition-colors py-1 duration-200 ${
          isHovered ? 'bg-semantic-bg-secondary' : ''
        }`}
        onClick={handleCopy}
        title="Click to copy"
      >
        {displayValue}
      </span>
    </div>
  );
};

export default CopyableValue;
